export function formatForMultiselectComponent(array, field) {
  return array.map((item) => {
    return {
      value: item.id,
      label: item[field],
    }
  });
}
